<template>
  <vs-popup
    :title="'Add table combination for ' + (clonedSection ? clonedSection.name : '')"
    :active.sync="showThisPopup"
    class="add-table-combo-popup">
    <vs-row vs-w="12">
      <vs-col vs-w="6">
        <div class="mt-2 flex">
          <vs-input class="inputx" label="Table name" placeholder="Example: 'Table 1'"
            v-model="shownTableName" :disabled="!tableNameEditMode"/>
          <vs-checkbox class="mt-4" v-model="tableNameEditMode" icon="edit" @change="handleTableNameEditModeChanged">
              <small>Edit mode</small>
            </vs-checkbox>
        </div>

        <div class="mt-2 flex">
            <vs-input class="inputx" type="number"
              label="Number of seats"
              v-model="shownSeatCount" :disabled="!seatCountEditMode"/>
            <vs-checkbox class="mt-4" v-model="seatCountEditMode" icon="edit" @change="handleSeatCountEditModeChanged">
              <small>Edit mode</small>
            </vs-checkbox>
        </div>

        <div class="mt-4">
        <h6>Current combination</h6>

          <vs-row v-if="!selectedNonComboTableNumbers || selectedNonComboTableNumbers.length === 0">
            <vs-col vs-w="12">
              <div class="my-1">No tables selected</div>
              <small>Select 2 or more tables to combine.</small>
            </vs-col>
          </vs-row>
          <vs-row v-if="selectedNonComboTableNumbers && selectedNonComboTableNumbers.length > 0">
            <vx-tooltip v-for="table in selectedNonComboTableNumbers"
              :key="'chip-'+table.id"
              :text="table.name" >
              <vs-chip
                :color="combinationIsValid() ? 'success' : 'danger'"
                >{{table.num}}
              </vs-chip>
            </vx-tooltip>
          </vs-row>
          <vs-row v-if="selectedTables && selectedTables.length === 1">
            <small>Select at least 1 more table for a valid combination.</small>
          </vs-row>

          <vs-row class="mt-4">
            <vs-col vs-w="12">
            Existing combinations with the selected tables:
              <div v-if="!selectedTables || selectedTables.length === 0">
                No tables selected
              </div>
              <div v-if="!comboTablesIncludingSelected || comboTablesIncludingSelected.length === 0">
                None
              </div>
              <ul>
                <li v-for="comboTable in comboTablesIncludingSelected"
                  :key="'li-chip-'+comboTable.id">
                  <vs-row vs-w="12">
                    <vx-tooltip v-for="nonComboTable in comboTable.parts"
                      :key="'li-chip-'+comboTable.id+'-'+nonComboTable.id"
                      :text="nonComboTable.name">
                      <vs-chip
                        :color="combinationIsValid() ? 'success' : 'danger'"
                        >{{nonComboTable.num}}
                      </vs-chip>
                    </vx-tooltip>
                  </vs-row>
                </li>
              </ul>
            </vs-col>
          </vs-row>
        </div>

      </vs-col>

      <vs-col vs-w="6" class="add-selected-tables mb-2">
        <vs-table stripe multiple v-model="selectedTables" :data="nonComboTables" v-if="clonedSection">
          <template slot="header">
            <h4 class="text-grey">Available Tables</h4>
          </template>
          <template slot="thead">
            <vs-th>
              #
            </vs-th>
            <vs-th>
              Table
            </vs-th>
            <vs-th>
              Seats
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <tbody>
            <vs-tr
              :data="tr"
              :key="indextr"
              v-for="(tr, indextr) in data"
              :state="
                rowIsPartOfSelection(tr) && combinationIsValid() ? 'success' :
                rowIsPartOfSelection(tr) && !combinationIsValid() ? 'danger' : null">

              <vs-td :data="data[indextr]">
                {{data[indextr].num}}
              </vs-td>

              <vs-td :data="data[indextr]">
                <div class="short-table-name">{{data[indextr].name}}</div>
              </vs-td>

              <vs-td :data="data[indextr]">
                {{data[indextr].seatCount}}
              </vs-td>

            </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </vs-col>

      <vs-col vs-lg="6">

      </vs-col>
    </vs-row>
    <vs-row vs-w="12" vs-justify="flex-end" >
      <vs-button color="primary" @click="handleAddTableClick" :disabled="!(validForm)">Add Table</vs-button>
    </vs-row>
  </vs-popup>
</template>

<script>
import { mapGetters } from "vuex";
import * as _ from "lodash";
import { ACTIONS as VENUE_ACTIONS} from "@/store/modules/marcom/marcom";

export default {
  components: { },
  data() {
    return {
      setup: undefined,
      tableName:'',
      tableNameEditMode: false,
      seatCount: 1,
      seatCountEditMode: false,
      showThisPopup: false,
      selectedTables: [],
      comboTables: [],
      nonComboTables: [],
      clonedSection: undefined,
    };
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      userId: "users/userId",
      isLoadingLocations: "marcom/isLoadingLocations",
      activeVenueSetups: "marcom/activeVenueSetups",
    }),
    validForm() {
      const nameIsValid = this.tableNameEditMode ? (!!this.tableName && !!this.tableName.trim()) : true;
      const seatCountIsValid = this.seatCountEditMode ? (!!this.seatCount && this.seatCount > 0) : true;
      return nameIsValid && seatCountIsValid && this.combinationIsValid();
    },
    selectedNonComboTableNumbers() {
      if(this.selectedTables && this.selectedTables.length > 0)
        return [...this.selectedTables].sort((t1,t2) => t1.num - t2.num);
      return [];
    },
    comboTablesIncludingSelected() {
      if(!this.selectedTables || this.selectedTables.length === 0) return [];

      const existingCombinations =
        this.comboTables.map(t=> {
          return {
            id: t.id,
            name: t.name,
            comboIds: [...t.combinationTablePartIds],
            parts: t.combinationTablePartIds
              .map(id => this.getNonComboTableById(id))
              .sort((t1,t2) => t1.num - t2.num)
          }
        });

      const selectedIds = this.selectedTables.map(t=>t.id).sort();
      return existingCombinations
        .filter(ec => _.intersection(ec.parts.map(p => p.id).sort(), selectedIds).length ===  selectedIds.length);
    },
    suggestedName() {
      return this.selectedTables.map(t => t.name).join('-');
    },
    suggestedSeatCount() {
      if(!this.selectedTables || this.selectedTables.length === 0) return 1;
      return this.selectedTables.map(t => t.seatCount).reduce((prev, curr) => prev + curr);
    },
    shownTableName: {
      get() {
        if(!this.tableNameEditMode) return this.suggestedName;
        return this.tableName;
      },
      set(value) {
        this.tableName = value;
      }
    },
    shownSeatCount: {
      get() {
        if(!this.seatCountEditMode) return this.suggestedSeatCount;
        return this.seatCount;
      },
      set(value) {
        this.seatCount = value;
        if (this.seatCount < 1) this.seatCount = 1;
      }
    }
  },
  methods: {
    show(section, setup) {
      this.clonedSection = _.cloneDeep(section);
      this.setup = setup;
      this.selectedTables = [];
      this.tableName = '';
      this.tableNameEditMode = false;
      this.seatCount = 1;
      this.seatCountEditMode = false;
      this.showThisPopup = true;
      this.comboTables = this.getComboTables();
      this.nonComboTables = this.getNonComboTables();
    },
    getComboTables() {
      if(!this.clonedSection) return [];
      return this.clonedSection.venueTables.filter(t =>
        !t.deleted &&
       (t.combinationTablePartIds && t.combinationTablePartIds.length > 0)
       );
    },
    getNonComboTables() {
      if(!this.clonedSection) return [];
      return this.clonedSection.venueTables.filter(t =>
        !t.deleted &&
       (!t.combinationTablePartIds || t.combinationTablePartIds.length === 0)
       ).map((t, i) => Object.assign({}, t, {num: i+1}));
    },
    getNonComboTableById(id){
      if(!this.nonComboTables) return undefined;
      return this.nonComboTables.find(t => t.id === id);
    },
    combinationIsValid() {
      if(!this.selectedTables || this.selectedTables.length < 2) return false;

      const existingCombinations =
      this.comboTables.map(t=>JSON.stringify([...t.combinationTablePartIds].sort()));

      const selectedIds = JSON.stringify(this.selectedTables.map(t=>t.id).sort());
      return !existingCombinations.includes(selectedIds);
    },
    rowIsPartOfSelection(tr) {
      return this.selectedTables.map(t=>t.id).includes(tr.id);
    },
    async handleAddTableClick() {
      try {
        this.$vs.loading();
        const tableIds = this.selectedTables.map(t=>t.id).sort();

        const tableCommand = {
            name: this.tableNameEditMode ? this.tableName: this.suggestedName,
            seatCount: this.seatCountEditMode ? this.seatCount: this.suggestedSeatCount,
            venueSetupId: this.setup.id,
            venueSectionId: this.clonedSection.id,
            note: "",
            combinationTablePartIds: tableIds
          };
        await this.$store.dispatch('marcom/' + VENUE_ACTIONS.AddTable, tableCommand);

        this.$vs.notify({
          color: "success",
          title: "Table combination added",
          text: "Table combination added",
        });

        this.handlePopupClose();
      } catch(err){
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Table combination added",
          text: "Oops, something went wrong",
        });
      }finally {
        this.$vs.loading.close();
      }
    },
    handlePopupClose() {
      this.showThisPopup = false;
    },
    handleTableNameEditModeChanged() {
      if(this.tableNameEditMode) this.tableName = this.suggestedName;
    },
    handleSeatCountEditModeChanged() {
      if(this.seatCountEditMode) this.seatCount = this.suggestedSeatCount;
    }
  },
};
</script>

<style lang="scss" scoped>
.add-table-combo-popup::v-deep .vs-popup {
  width: 1080px;

  .short-table-name {
    max-width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .vs-popup--content {
    overflow: hidden;

    .add-selected-tables {
        max-height: calc(100vh - 225px);
        overflow: auto;
        //margin-top: 10px;
        //margin-bottom: 10px;
    }
  }
}
</style>
